<template>
    <div class="onboarding-screen__button" @click="openPanel">
        <CompassIcon icon="custom-checks" size="large" class="onboarding-screen__button--icon" />
        <span class="onboarding-screen__button--label typographies-paragraph-small-semibold">
            {{ $l10n.__('Commencer avec Sellsy') }}
        </span>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    methods: {
        ...popupPanelMapActions(['open']),

        openPanel() {
            this.open({
                key: 'onboardingScreenPanel',
                props: {},
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.onboarding-screen__button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: var(--spacing-0) var(--spacing-1);
    gap: var(--spacing-1);
    border-radius: 4px;
    background-color: var(--colors-component-background-illustration-brand-secondary-grey);
    cursor: pointer;

    &:hover {
        background-color: var(--colors-common-background-primary-hover-alt);
    }

    &--icon {
        flex-shrink: 0;
    }

    &--label {
        color: var(--colors-common-text-brand-secondary-blue);
    }
}
</style>
